import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ProductDetailsCard, Typography } from 'mobily-ui-library';
import { GlobalContext } from '../../../context/GlobalContext';

import ErrorModal from '../../ErrorModal/ErrorModal';

import { removeAndCancelCart } from '../../../api/api';

import { handleApiError } from '../../../functions/handleApiError';

import { deleteCookies } from '../../../Utils/deleteCookies';

import Brand from '../../../assets/Brand.svg';
import Tick from '../../../assets/Tick.svg';

import './SubsidySuccess.scss';

const win: any = window;
const serverURL = win['base_portal_url'];
const cartPage = win['cart_app_url'];

function SubsidySuccess() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, productData, cartId, promotionType, promoPeriod, promoAmount, deviceFlow, appliedInstallment, subPageToDisplay:  stepName, updatedProductPrice, graphQlResponse } = state;

    const { t } = useTranslation();

    const eligiblePreOrder = graphQlResponse?.getProductOfferByID?.[0]?.specCharValueUse
        ?.filter(
            (val: any) => val.name === "Is Eligible For Pre Order"
        )[0];

    const preOrder = eligiblePreOrder?.specCharacteristicValue?.[0]?.value === "true" ? true : false;
    const backOrder = productData?.backOrder ? productData?.backOrder : false;
    const isOutOfStock = false;
    let colorCode;
    let capacity;
    if (productData?.category?.deviceSubType.valueEn === "Smart Watches") {
        colorCode = rtl ? productData?.caseColorCode.valueAr : productData?.caseColorCode.valueEn;
        capacity = rtl ? productData?.caseSize.valueAr : productData?.caseSize.valueEn;
    } else {
        colorCode = rtl ? productData?.colorCode.valueAr : productData?.colorCode.valueEn;
        capacity = rtl ? productData?.capacity.valueAr : productData?.capacity.valueEn;
    }

    const productDescription = `${colorCode}, ${capacity}`;
    const productInstalmentPrice = `${t('SAR')} ${appliedInstallment?.TotalDeviceInstallmentAmount}`;
    const productSubsidyPrice = `${t('SAR')} ${updatedProductPrice}`
    // const productPrice = `${t('SAR')} ${productData?.priceWithoutVAT}`;
    const productName = rtl ? productData?.category.name.valueAr : productData?.category.name.valueEn
    const productImage = serverURL + productData?.category.defaultURL;
    const installmentMonths = appliedInstallment?.PromotionCommitmentPeriod ? appliedInstallment?.PromotionCommitmentPeriod : "";
    const installmenAmount = appliedInstallment?.MonthlyCommitmentAmt ? appliedInstallment?.MonthlyCommitmentAmt : "";
    const [removeClick, setRemoveClick] = useState(false)

    const handleRemoveSubsidy = () => {
        setRemoveClick(true)
    }

    const handleGoToCart = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        window.location.href = `${serverURL}${cartPage}`;
    }

    const handleModalKeepSubsidy = () => {
        setRemoveClick(false);
        document.body.style.overflow = 'auto';
    }

    const handleModalRemoveSubsidy = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        document.body.style.overflow = 'auto';

        removeAndCancelCart(cartId)
            .then((res: any) => {
                if (res.status === 201 && res.data) {
                    deleteCookies('device-count');
                    deleteCookies('device-scId');
                    deleteCookies('device-xCoId');
                    deleteCookies('device-poid');
                    deleteCookies('device-journeyName');
                    sessionStorage.removeItem('device-flow');
                    window.location.reload();
                    const wcmElement: any = document.getElementById("reactWCMControlBlockID");
                    if (wcmElement !== null) {
                        wcmElement.style.display = 'block';
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }

    return (
        <>

            <div className='Devices__SubsidySuccess'>
                <ProductDetailsCard
                    rtl={rtl}
                    status={!backOrder && preOrder ? t('pre_order') : ""}
                    borderON={true}
                    beforeDiscount=""
                    devicesImage={productImage}
                    productDescription={productDescription}
                    productName={productName}
                    productPrice={isOutOfStock ? t('sold_out') : deviceFlow === 'subsidy' ? productSubsidyPrice : productInstalmentPrice}
                    Trashicon={true}
                    promotionTextTitle={deviceFlow === 'subsidy' ? "" : `${t('installment')} ${t('SAR')} ${installmenAmount} ${t('sar_month')} (${t('vat_exclusive')})`}
                    promotionTextSubtitle={deviceFlow === 'subsidy' ? "" : `(${installmentMonths} ${t('Months_commitment')})`}
                />

                <div className='Devices__SubsidyType'>
                    <Typography rtl={rtl} className='DST__FinanceTitle'>{t('Mobily_Financing')}</Typography>

                    <div className='DST__Apply'>
                        <div className='DST__ApplyHead'>
                            <img src={Brand} alt='mobily-icon' />
                            <Typography rtl={rtl} className='DST__ApplyTitle'>{deviceFlow === 'subsidy' ? t('Device_subsidy') : t('device_installment')}</Typography>
                        </div>
                        <Typography id={deviceFlow === 'subsidy' ? "pdp_subsidyApplied" : "pdp_installmentApplied"} rtl={rtl} className='DST__ApplyContent'>
                            {deviceFlow === 'subsidy' ? (
                                rtl ? `فترة التزام مقابل ${promoAmount} ريال لمدة ${promoPeriod} شهر، ساري فقط لباقات مفوتر محددة.تطبق الشروط والأحكام.` : `${promoAmount} SAR with a commitment period of ${promoPeriod} months. For selected Postpaid plans only. T&Cs apply`
                            ) : (
                                t('get_your_device_with_installment', { installment_amount_montly: installmenAmount, committed_months: installmentMonths })
                            )}
                        </Typography>

                        <Typography rtl={rtl} className='DST__ApplyLink'>
                            <img src={Tick} alt='arrow' />
                            <span className='DST__Success'>{deviceFlow === 'subsidy' ? `${promotionType} ${t('subsidy_applied')}` : t('installment_applied')}</span>
                            <span className='DST__ApplyRemove' onClick={handleRemoveSubsidy}>{t('Remove')}</span>
                        </Typography>
                    </div>
                </div>

                <div className='Devices__SubsidyStickyBox'>
                    <Button
                        rtl={rtl}
                        className='DSSTB__ApplyBtn'
                        onClick={handleGoToCart}
                    >
                        {t('Go_To_Cart')}
                    </Button>
                </div>
            </div>

            {removeClick && (
                <ErrorModal
                    id='duplicate-shopping-cartId'
                    rtl={rtl}
                    title={deviceFlow === 'subsidy' ? t('Remove_subsidy') : t('remove_installment')}
                    description={deviceFlow === 'subsidy' ? t('Are_you_remove_Subsidy') : t('are_you_sure_want_to_remove_installment')}
                    firstButtonText={deviceFlow === 'subsidy' ? t('Keep_subsidy') : t('keep_installment_button')}
                    secButtonText={deviceFlow === 'subsidy' ? t('Remove_subsidy_btn') : t('remove_installment_button')}
                    modalFirstButtonClick={handleModalKeepSubsidy}
                    modalSecondButtonClick={handleModalRemoveSubsidy}
                />
            )}
        </>
    )
}

export default SubsidySuccess